import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';

import { admin } from './reducers/admin';
import adminReducer from './reducers/adminSlice';
import animalReducer from './reducers/animal';
import authReducer from './reducers/auth';
import { breed } from './reducers/breed';
import { breeding } from './reducers/breeding';
import breedingReducer from './reducers/breedingSlice';
import { calendar } from './reducers/calendar';
import dashboardReducer from './reducers/dashboard';
import embeddableReducer from './reducers/embeddable';
import { event } from './reducers/event';
import farmReducer from './reducers/farm';
import filtersReducer from './reducers/filters';
import gatewayReducer from './reducers/gateway';
import geofenceReducer from './reducers/geofence';
import rotationReducer from './reducers/geofence-rotations';
import grazingReducer from './reducers/grazing';
import { invitation } from './reducers/invitations';
import invoice from './reducers/invoices';
import labelReducer from './reducers/label';
import mapReducer from './reducers/map';
import matingEventReducer from './reducers/mating-event';
import measurementReducer from './reducers/measurement';
import { notification } from './reducers/notification';
import notificationsReducer from './reducers/notifications';
import ruleReducer from './reducers/rule';
import siteReducer from './reducers/site';
import { subscription } from './reducers/subscription';
import tableReducer from './reducers/table';
import { tableConfigurations } from './reducers/table-configurations';
import tagReducer from './reducers/tag';
import { task } from './reducers/task';
import treatmentReducer from './reducers/treatment';
import { user } from './reducers/user';
import userReducer from './reducers/userSlice';

const rootReducer = {
  admin,
  adminSlice: adminReducer,
  animal: animalReducer,
  auth: authReducer,
  breed,
  breeding,
  breedingSlice: breedingReducer,
  calendar,
  dashboard: dashboardReducer,
  embeddable: embeddableReducer,
  event,
  farm: farmReducer,
  filters: filtersReducer,
  gateway: gatewayReducer,
  geofence: geofenceReducer,
  grazing: grazingReducer,
  invitation,
  label: labelReducer,
  map: mapReducer,
  matingEvent: matingEventReducer,
  measurement: measurementReducer,
  notification,
  notifications: notificationsReducer,
  rotation: rotationReducer,
  rule: ruleReducer,
  site: siteReducer,
  subscription,
  table: tableReducer,
  tableConfigurations,
  tag: tagReducer,
  task,
  treatment: treatmentReducer,
  user,
  userSlice: userReducer,
  invoice
};

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(thunk)
});

export default store;
